var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVertPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15367_15280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15367_15280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.269C11.5875 19.269 11.2344 19.1221 10.9408 18.8282C10.6469 18.5346 10.5 18.1815 10.5 17.769C10.5 17.3565 10.6469 17.0033 10.9408 16.7095C11.2344 16.4158 11.5875 16.269 12 16.269C12.4125 16.269 12.7656 16.4158 13.0592 16.7095C13.3531 17.0033 13.5 17.3565 13.5 17.769C13.5 18.1815 13.3531 18.5346 13.0592 18.8282C12.7656 19.1221 12.4125 19.269 12 19.269ZM12 13.4997C11.5875 13.4997 11.2344 13.3528 10.9408 13.059C10.6469 12.7653 10.5 12.4122 10.5 11.9997C10.5 11.5872 10.6469 11.2341 10.9408 10.9405C11.2344 10.6466 11.5875 10.4997 12 10.4997C12.4125 10.4997 12.7656 10.6466 13.0592 10.9405C13.3531 11.2341 13.5 11.5872 13.5 11.9997C13.5 12.4122 13.3531 12.7653 13.0592 13.059C12.7656 13.3528 12.4125 13.4997 12 13.4997ZM12 7.73047C11.5875 7.73047 11.2344 7.58364 10.9408 7.28997C10.6469 6.99614 10.5 6.64297 10.5 6.23047C10.5 5.81797 10.6469 5.46489 10.9408 5.17122C11.2344 4.87739 11.5875 4.73047 12 4.73047C12.4125 4.73047 12.7656 4.87739 13.0592 5.17122C13.3531 5.46489 13.5 5.81797 13.5 6.23047C13.5 6.64297 13.3531 6.99614 13.0592 7.28997C12.7656 7.58364 12.4125 7.73047 12 7.73047Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertPortfolio);
export default __webpack_public_path__ + "static/media/more_vert_portfolio.7e750c0b9a6144fd49fc6be71fc6207b.svg";
export { ForwardRef as ReactComponent };